import React from 'react';
import { useRecoilValue } from 'recoil';

import { PlaylistMarkdownPreview } from 'features/classCreation';
import { sbatGroupPlaylistContent } from 'atoms/sbatGroupPlaylistContent';
import styles from './PlaylistMarkdownRenderer.module.scss';

function PlaylistMarkdownRenderer() {
  const content = useRecoilValue(sbatGroupPlaylistContent);

  return (
    <PlaylistMarkdownPreview
      mdString={content}
      className={styles.root}
    />
  );
}

export default PlaylistMarkdownRenderer;
